module.exports = __webpack_public_path__ + "img/Shutterstock.0fc2f0d7.png";